import React from 'react';
import PropTypes from 'prop-types';

import {DeleteIconButton} from 'components/controls';
import {noop} from 'components/helpers/funcTools';

function StringArrayItem(props) {
    const {
        value,
        index,
        onDelete,
        className,
    } = props;

    const handleClick = (e) => {
        onDelete(e, index);
    };

    return (
        <div className={className}>
            {value}
            <DeleteIconButton onClick={handleClick} />
        </div>
    );
}

StringArrayItem.propTypes = {
    value: PropTypes.string,
    index: PropTypes.number.isRequired,
    onDelete: PropTypes.func.isRequired,
    className: PropTypes.string,
};

StringArrayItem.defaultProps = {
    value: '',
    className: '',
};

export default StringArrayItem;



// WEBPACK FOOTER //
// ./src/components/controls/form/StringArrayFormField/StringArrayItem.jsx